import { Component } from '@angular/core';
import { HeaderLatestComponent } from 'src/app/home/landing-root/header-latest/header-latest.component';

import { PeopleflowFooterComponent } from 'src/app/peopleflow-footer/peopleflow-footer.component';

@Component({
  selector: 'app-apireference-custom',
  imports: [HeaderLatestComponent, PeopleflowFooterComponent],
  templateUrl: './apireference-custom.html',
  styleUrl: './apireference-custom.scss',
})
export class ApireferenceCustom {

}
